import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, Typography, InputAdornment, IconButton } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ArrowDown2, ArrowUp2, Calendar } from 'iconsax-react';
import { useState } from 'react';
import { palette } from '../../../../theme/palette';
const theme = palette('light');
export default function CustomDatePicker({ label = 'Select Date', value, onChange, labelColor = '#141414', fillBackground = true, borderRadius = true, disabled = false, height, errormsg, mt = 0, format = 'MM-DD-YYYY' }) {
    const [open, setOpen] = useState(false);
    return (_jsx(Box, { width: '100%', mt: mt, className: 'custom-select', children: _jsxs(FormControl, { fullWidth: true, children: [_jsx(Typography, { style: {
                        fontSize: '14px',
                        color: labelColor ? labelColor : '#B1B1B1',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        display: 'inline-block',
                        maxWidth: '300px'
                    }, variant: 'body2', children: label }), _jsx(DatePicker, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), disabled: disabled, value: value, onChange: onChange, format: format, slots: {
                        openPickerIcon: open ? ArrowUp2 : ArrowDown2
                    }, slotProps: {
                        textField: {
                            fullWidth: true,
                            variant: 'outlined',
                            error: !!errormsg,
                            placeholder: label,
                            InputProps: {
                                sx: {
                                    backgroundColor: fillBackground ? (disabled ? '#ECECEC' : '#f8f8f8') : 'white',
                                    color: labelColor,
                                    borderRadius: borderRadius ? '8px' : '25px',
                                    height: height || '50px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'transparent'
                                    }
                                },
                                endAdornment: (_jsx(InputAdornment, { position: 'end', children: _jsx(IconButton, { tabIndex: -1, disabled: disabled, onClick: () => setOpen(!open), edge: 'end', children: _jsx(Calendar, {}) }) }))
                            }
                        }
                    } }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: -19, left: 0 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, color: '#FF0000', children: errormsg }) }))] }) }));
}
